import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress React 19 portal cleanup errors (removeChild) - prevent error overlay
const originalConsoleError = console.error;
console.error = (...args) => {
  const msg = args[0]?.toString?.() || '';
  if (
    msg.includes('removeChild') ||
    msg.includes('introuvable') ||
    msg.includes('not a child') ||
    msg.includes('The node to be removed')
  ) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// Intercept unhandled errors to prevent the error overlay from showing for DOM errors
window.addEventListener('error', (event) => {
  const msg = event.message || event.error?.message || '';
  if (
    msg.includes('removeChild') ||
    msg.includes('introuvable') ||
    msg.includes('not a child') ||
    msg.includes('The node to be removed') ||
    msg.includes('removeChildFromContainer')
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message || String(event.reason) || '';
  if (
    msg.includes('removeChild') ||
    msg.includes('introuvable') ||
    msg.includes('not a child')
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
